export const createNamespacedReducer = ({ reducer, module, namespace }) => ({
  [`${namespace}/${module}`]: reducer(namespace),
});

export default {};
